import { PLACEHOLDER } from './CONSTANTS';

const getConfig = ({
    editorIdentifier = 'default',
    debug = false,
    readOnly = false,
    spellCheck = false,
    enableAutoSave = true,
    enableTables = true,
    enableEmbeds = true,
    enableFileUpload = true,
    enableImageUpload = true,
    enableDragToUpload = true,
    enableHighlightControls = true,
    enableInsertControls = true,
    enableMentionSuggestions = true,
    enableInternalSuggestions = true,
    enableExternalSuggestions = true,
    enableExternalFocus = false,
    disableTabInSmallEditor = true,
    textPlaceholder = PLACEHOLDER,
    imagePlaceholder = '/img/image-placeholder.gif',
    fileApi = '/api/files',
    enableSmallEditor = false,
    enableChoosePageDialog = false,
    commentEditor = false,
}) => ({
    editorIdentifier,
    debug,
    readOnly,
    spellCheck,
    enableAutoSave,
    enableTables,
    enableEmbeds,
    enableFileUpload,
    enableImageUpload,
    enableDragToUpload,
    enableHighlightControls,
    enableInsertControls,
    enableMentionSuggestions,
    enableInternalSuggestions,
    enableExternalSuggestions,
    enableExternalFocus,
    enableSmallEditor,
    enableChoosePageDialog,
    disableTabInSmallEditor,
    textPlaceholder,
    imagePlaceholder,
    fileApi,
    commentEditor,
});

export default getConfig;
